"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLORS = void 0;
exports.COLORS = {
    // Primary Theme Colors
    primary: "#3F0997",
    backgroundPrimary: "#D9D9D9", // Pure White (main background)
    backgroundSecondary: "#E9E3F3", // Light Gray (secondary background)
    textPrimary: "#2D3436", // Charcoal (main body text)
    textSecondary: "#5C5C5C", // Dark Gray (subtle labels, captions)
    textInverted: "#FFFFFF", // Pure White (text on dark backgrounds)
    textInteractive: "#007AFF", // Electric Blue (links, clickable text)
    textSuccess: "#2E7D32", // Success Green (confirmation messages)
    textError: "#FF4444", // Alert Red (error messages)
    textWarning: "#FFD700", // Luxury Gold (warning toasts)
    // Status Colors
    success: "#4E9F3D", // Olive green for positive actions
    warning: "#FF9F45", // Warm orange for warnings
    error: "#D63447", // Deep redwood red for errors
    info: "#0081CF", // Cool cyan for informative messages
};
//# sourceMappingURL=color.js.map